import { filter, map, switchMap } from "rxjs/operators";
import { selectBalancingOutskirt } from "../../../../balancingSelectors/selectBalancingOutskirts";
import { selectOutskirtBuildingBundleByBuildingId, selectOutskirtBuildingLevel, } from "../../../../selectors/selectOutskirtBuildingInfo";
import { selectOutskirtBuildingVisualLevelFromInfo } from "../../../../selectors/selectOutskirtBuildingInfo";
import { utilLoader } from "../../../../utils/loader/utilLoader";
import { createLoaderEventToActionMapper } from "../../../loading/createLoaderEventToActionMapper";
import { IdAssetBundleCore } from "../../../loading/IdAssetBundleCore";
import { TypeActionOutskirtsInfo } from "../actionOutskirtsInfo";
export var epicLoadOutskirtBuildingOnUpgrade = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionOutskirtsInfo.UpgradeRequest ||
            action.type === TypeActionOutskirtsInfo.LoadNextLevelAssets;
    }), switchMap(function (action) {
        var state = state$.value;
        var outskirtBuildingId = action.building.balancing.id;
        var nextBuildingStage = selectOutskirtBuildingLevel(state, outskirtBuildingId) + 2;
        var nextBuildingInfo = {
            balancing: selectBalancingOutskirt(outskirtBuildingId),
            proto: {
                stage: nextBuildingStage,
            },
        };
        var nextLevel = selectOutskirtBuildingVisualLevelFromInfo(nextBuildingInfo);
        var outskirtBundle = selectOutskirtBuildingBundleByBuildingId(state, outskirtBuildingId, nextLevel, true);
        return utilLoader
            .load(IdAssetBundleCore.Outskirts, outskirtBundle)
            .pipe(map(createLoaderEventToActionMapper(IdAssetBundleCore.Outskirts)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicLoadOutskirtBuildingOnUpgrade.ts
// module id = 1915
// module chunks = 3